module.exports = __webpack_public_path__ + "static/media/table.fd3e616f.svg";